import React from "react";

export default function EndRecommandations({ onClose }) {
  return (
    <div className="relative z-[2] flex flex-1 flex-col items-center overflow-y-auto pt-6">
      <CheckSvg />
      <h2 className="text-center">
        Félicitations ! Votre inscription à l’infolettre a bien été prise en
        compte.
      </h2>
      <p className="text-center">
        Vous pourrez modifier vos préférences une fois le mail de confirmation
        reçu.
      </p>
      <button
        className="mb-4 inline-flex items-center gap-x-2 rounded-full border-2 border-main bg-main px-4 py-3 text-white disabled:opacity-50"
        type="button"
        onClick={onClose}
      >
        Retourner à l'accueil
      </button>
    </div>
  );
}

function CheckSvg() {
  return (
    <svg
      className="my-8 h-20 w-20 shrink-0"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.9992 49.6C59.5581 49.6 59.1992 49.2411 59.1992 48.8C59.1992 48.3588 59.5581 48 59.9992 48C60.4403 48 60.7992 48.3588 60.7992 48.8C60.7992 49.2411 60.4403 49.6 59.9992 49.6Z"
        fill="#CACAFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.1984 4.8002C46.7573 4.8002 46.3984 4.44132 46.3984 4.0002C46.3984 3.55904 46.7573 3.2002 47.1984 3.2002C47.6396 3.2002 47.9984 3.55904 47.9984 4.0002C47.9984 4.44132 47.6396 4.8002 47.1984 4.8002Z"
        fill="#CACAFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99922 54.4003C7.5581 54.4003 7.19922 54.0414 7.19922 53.6003C7.19922 53.1591 7.5581 52.8003 7.99922 52.8003C8.44034 52.8003 8.79922 53.1591 8.79922 53.6003C8.79922 54.0414 8.44034 54.4003 7.99922 54.4003Z"
        fill="#CACAFB"
      />
      <path
        d="M9.60039 20.7998C9.60039 21.2409 9.95927 21.5998 10.4004 21.5998C10.8415 21.5998 11.2004 21.2409 11.2004 20.7998C11.2004 20.3586 10.8415 19.9998 10.4004 19.9998C9.95927 19.9998 9.60039 20.3586 9.60039 20.7998Z"
        fill="#E1000F"
      />
      <path
        d="M12.8004 21.5998C12.3593 21.5998 12.0004 21.2409 12.0004 20.7998C12.0004 20.3586 12.3593 19.9998 12.8004 19.9998C13.2415 19.9998 13.6004 20.3586 13.6004 20.7998C13.6004 21.2409 13.2415 21.5998 12.8004 21.5998Z"
        fill="#E1000F"
      />
      <path
        d="M14.4004 20.7998C14.4004 21.2409 14.7593 21.5998 15.2004 21.5998C15.6415 21.5998 16.0004 21.2409 16.0004 20.7998C16.0004 20.3586 15.6415 19.9998 15.2004 19.9998C14.7593 19.9998 14.4004 20.3586 14.4004 20.7998Z"
        fill="#E1000F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.20039 16.7998H18.4004C18.8422 16.7998 19.2004 17.158 19.2004 17.5998V23.9998C19.2004 24.4416 18.8422 24.7998 18.4004 24.7998H16.0004V25.5998C16.0004 26.1632 15.4387 26.54 14.9273 26.352L14.8426 26.3153L11.8116 24.7998H7.20039C6.79012 24.7998 6.45198 24.491 6.40577 24.0931L6.40039 23.9998V17.5998C6.40039 17.158 6.75856 16.7998 7.20039 16.7998ZM15.2004 23.1998H17.6004V18.3998H8.00039V23.1998H12.0004C12.0935 23.1998 12.1857 23.2161 12.2729 23.2476L12.3582 23.2843L14.4004 24.3054V23.9998C14.4004 23.5895 14.7092 23.2514 15.1071 23.2052L15.2004 23.1998Z"
        fill="#E1000F"
      />
      <path
        d="M40.8004 23.1998C40.3586 23.1998 40.0004 23.558 40.0004 23.9998C40.0004 24.4416 40.3586 24.7998 40.8004 24.7998C41.2422 24.7998 41.6004 24.4416 41.6004 23.9998C41.6004 23.558 41.2422 23.1998 40.8004 23.1998Z"
        fill="#E1000F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.8004 19.9998C38.5912 19.9998 36.8004 21.7907 36.8004 23.9998C36.8004 26.2089 38.5912 27.9998 40.8004 27.9998C43.0095 27.9998 44.8004 26.2089 44.8004 23.9998C44.8004 21.7907 43.0095 19.9998 40.8004 19.9998ZM40.8004 21.5998C42.1259 21.5998 43.2004 22.6743 43.2004 23.9998C43.2004 25.3253 42.1259 26.3998 40.8004 26.3998C39.4749 26.3998 38.4004 25.3253 38.4004 23.9998C38.4004 22.6743 39.4749 21.5998 40.8004 21.5998Z"
        fill="#E1000F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.201 16.8C35.201 13.749 34.1516 12 32.001 12C29.8504 12 28.801 13.749 28.801 16.8C28.801 16.9003 28.8194 16.9963 28.8531 17.0847C24.3808 17.9739 21.8456 20.9652 21.0593 26.3395L20.9857 26.8916C20.8391 28.1054 20.7763 29.4343 20.7953 30.8812L20.8012 31.2172L20.7977 31.9104L20.8103 32.2893C20.8282 33.8657 20.2248 35.8848 19.3455 37.1413L16.2324 41.4745L16.155 41.5957C16.0117 41.8431 15.9375 42.1186 15.9375 42.4C15.9375 43.2837 16.6538 44 17.5375 44L25.601 44C25.601 48.1752 27.8258 50.4 32.001 50.4C36.1761 50.4 38.401 48.1752 38.401 44L46.4644 44L46.6045 43.9939C46.8832 43.9694 47.1515 43.8721 47.382 43.7108C48.1059 43.204 48.282 42.2064 47.7752 41.4825L44.6507 37.1332L44.5011 36.9104C43.7191 35.6938 43.1997 34.0383 43.1997 32.681L43.2007 32.0226L43.2122 31.4944C43.2176 31.1457 43.2183 30.8037 43.2144 30.4682C43.2093 30.0264 42.8469 29.6725 42.4051 29.6776C41.9633 29.6828 41.6094 30.0451 41.6145 30.4869C41.6202 30.9685 41.6157 31.4652 41.6013 31.9774L41.5997 32.6808L41.6054 32.9641C41.6735 34.6785 42.3469 36.6366 43.3463 38.0598L46.4642 42.3992L17.5375 42.4L20.6507 38.0668L20.7965 37.85C21.8483 36.2246 22.5036 33.8357 22.3998 31.9559L22.3982 31.9174L22.4008 31.1828L22.3951 30.8604C22.2744 22.0059 25.1827 18.4 32.001 18.4C33.9478 18.4 35.5655 18.7369 36.8766 19.4071C37.27 19.6082 37.7519 19.4523 37.9531 19.0589C38.1542 18.6655 37.9983 18.1836 37.6049 17.9825C36.8551 17.5992 36.0328 17.3104 35.1369 17.1143C35.1781 17.0178 35.201 16.9116 35.201 16.8ZM33.6045 16.8755C33.6022 16.8506 33.601 16.8254 33.601 16.8C33.601 14.5177 33.0504 13.6 32.001 13.6C30.9516 13.6 30.401 14.5177 30.401 16.8C30.401 16.8227 30.4 16.8452 30.3982 16.8674C30.9109 16.8224 31.4451 16.8 32.001 16.8C32.5561 16.8 33.0906 16.8251 33.6045 16.8755ZM27.201 44C27.201 47.2915 28.7095 48.8 32.001 48.8C35.2925 48.8 36.801 47.2915 36.801 44H27.201Z"
        fill="#000091"
      />
      <path
        d="M32.001 54.4C34.8115 54.4 37.2291 53.5033 38.9667 51.7657C39.2791 51.4533 39.2791 50.9467 38.9667 50.6343C38.6542 50.3219 38.1477 50.3219 37.8353 50.6343C36.4143 52.0553 34.4066 52.8 32.001 52.8C31.5591 52.8 31.201 53.1582 31.201 53.6C31.201 54.0418 31.5591 54.4 32.001 54.4Z"
        fill="#000091"
      />
      <path
        d="M40.801 49.6C40.3599 49.6 40.001 49.2411 40.001 48.8C40.001 48.3588 40.3599 48 40.801 48C41.2421 48 41.601 48.3588 41.601 48.8C41.601 49.2411 41.2421 49.6 40.801 49.6Z"
        fill="#000091"
      />
      <path
        d="M53.601 28C54.0428 28 54.401 28.3582 54.401 28.8C54.401 29.2103 54.0921 29.5484 53.6943 29.5946L53.601 29.6H50.401C49.9591 29.6 49.601 29.2418 49.601 28.8C49.601 28.3897 49.9098 28.0516 50.3077 28.0054L50.401 28H53.601Z"
        fill="#000091"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.201 24.8H56.801C57.2428 24.8 57.601 25.1582 57.601 25.6V32L57.5956 32.0933C57.5494 32.4912 57.2112 32.8 56.801 32.8H53.7898L50.7587 34.3155L50.6741 34.3522C50.1627 34.5402 49.601 34.1634 49.601 33.6V32.8H47.201C46.7591 32.8 46.401 32.4418 46.401 32V25.6C46.401 25.1582 46.7591 24.8 47.201 24.8ZM48.001 26.4V31.2H50.401L50.4943 31.2054C50.8921 31.2516 51.201 31.5897 51.201 32V32.3056L53.2432 31.2845L53.3285 31.2478C53.4156 31.2163 53.5078 31.2 53.601 31.2H56.001V26.4H48.001Z"
        fill="#000091"
      />
    </svg>
  );
}
